import { getApi } from "src/api/ApiProvider";
import { AppDispatch } from ".";
import StoreModel from "./StoreModel";
import { Dispatch } from "react-redux";
import { NotificationActions } from "./notification/notification-actions";
import { Action } from "redux";
import initialState from "src/initialState";

export enum BranchActionTypes {
    FETCH_REQUEST = '[BRANCH][LIST] Request',
    FETCH_RESPONSE = '[BRANCH][LIST] Response',
    FETCH_ERROR = '[BRANCH][ERROR] Error',

    ADD_REQUEST = '[BRANCH][ADD] Request',
    ADD_RESPONSE = '[BRANCH][ADD] Response',
    ADD_ERROR = '[BRANCH][ADD] Error',

    DELETE_REQUEST = '[BRANCH][DELETE] Request',
    DELETE_RESPONSE = '[BRANCH][DELETE] Response',
    DELETE_ERROR = '[BRANCH][DELETE] Error',
}

export interface BranchStore {
    data: {
        fetching: boolean,
        error?: any,
        data?: any
    },
    add: {
        fetching: boolean,
        error?: any,
        data?: any
    }
}

export default (
    state: BranchStore = initialState.branch,
    action?: Action<BranchActionTypes> & { payload: any }): BranchStore => {

    if (!action) {
        return state;
    }

    switch (action.type) {
        case BranchActionTypes.FETCH_REQUEST:
            return {
                ...state,
                data: StoreModel.fetching()
            };
        case BranchActionTypes.FETCH_RESPONSE:
            return {
                ...state,
                data: StoreModel.result(action.payload),
            };
        case BranchActionTypes.FETCH_ERROR:
            return {
                ...state,
                data: StoreModel.error(action.payload),
            };
        case BranchActionTypes.ADD_REQUEST:
            return {
                ...state,
                add: StoreModel.fetchingSingle()
            };
        case BranchActionTypes.ADD_RESPONSE:
            return {
                ...state,
                add: StoreModel.resultSingle(action.payload)
            }
        case BranchActionTypes.ADD_ERROR:
            return {
                ...state,
                add: StoreModel.errorSingle(action.payload)
            }
        default:
            return state;
    }
}
const notif = new NotificationActions();
export class BranchActions {
    add(data: any) {
        return (dispatch: AppDispatch) => {
           
            dispatch({ type: BranchActionTypes.ADD_REQUEST });

            getApi().branch().add(data).then((response) => {
                dispatch(notif.addSuccess('Sucursal', 'Sucursal creada'));
                dispatch({ type: BranchActionTypes.ADD_RESPONSE, payload: response });
                dispatch(this.fetch() as any);
            }).catch(err => {
                dispatch({ type: BranchActionTypes.ADD_ERROR, payload: err });
                dispatch(notif.addError('Sucursal', err.response ? err.response.message : err.message) as any);
            });
        }
    }

    fetch() {
        return (dispatch: Dispatch) => {
            dispatch({ type: BranchActionTypes.FETCH_REQUEST });
            getApi().branch().listAllBranchesAdmin().then(data => {
                dispatch({ type: BranchActionTypes.FETCH_RESPONSE, payload: data });
            }).catch(err => {
                dispatch({ type: BranchActionTypes.FETCH_ERROR, payload: err });
            })
        }
    }

    update(id: number, data: { name: string, lat: number, lng: number, street1: string, street2: string, observation: string, number: string, companyId: number }) {
        return (dispatch: AppDispatch) => {
            getApi().branch().update(id, data).then((response) => {
                dispatch({ type: BranchActionTypes.ADD_RESPONSE, payload: response });
                dispatch(notif.addSuccess('Sucursal', 'Actualización correcta') as any);
                dispatch(this.fetch() as any);
            }).catch(err => {
                dispatch({ type: BranchActionTypes.ADD_ERROR, payload: err });
            });
        }
    }

    delete(id: number) {
        return (dispatch: AppDispatch) => {
            if (!id) {
                return;
            }
            dispatch({ type: BranchActionTypes.DELETE_REQUEST });
            getApi().branch().delete(id).then(response => {
                console.log(response);
                dispatch(notif.addSuccess('Sucursal', 'Eliminación correcta') as any);
                dispatch({ type: BranchActionTypes.DELETE_RESPONSE, payload: response.message });
                dispatch(this.fetch());
            }).catch(err => {
                console.error(err);
                dispatch(notif.addError('Sucursal', err.response.message) as any);
                dispatch({ type: BranchActionTypes.DELETE_ERROR, payload: err.message });
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/branch.ts